export default [
  {
    path: '/login',
    name: 'login',
    meta:{
      title:"登录页"
    },
    component: () => import('@/views/login/index.vue')
  }
]